import loder from 'loder';
import EnvUtils from '@xfe-team/utils/src/env-utils';

export default function inject(scriptModels) {
  const availableKeys = Object.keys(scriptModels).filter(key => {
    const scriptModel = scriptModels[key];
    const { condition, env } = scriptModel;
    return condition && isMatchCurrentEnv(env);
  });
  const promises = availableKeys.map(key => {
    const scriptModel = scriptModels[key];
    const { script, resolve, reject, prepare } = scriptModel;
    prepare();
    const promise = loder.loadScript(script);
    loder.add(key, promise.then(resolve, reject));
    return promise;
  });
  return Promise.all(promises);
}

function isMatchCurrentEnv(env) {
  const currentEnv = EnvUtils.getEnv();
  return env === undefined || env === currentEnv || (Array.isArray(env) && ~env.indexOf(currentEnv));
}



// WEBPACK FOOTER //
// ./src/initialize/inject-scripts/libs/inject.js